import {
  GET_ORDER_ITEMS,
  SET_PAGE,
  SET_SEARCH,
} from "../../shared/constants/ActionTypes";

const initialOrderItems = {
  orderItemsData: [],
  orderItemsCount: 0,
  page: 1,
  search: "",
};

const OrderItemsReducer = (state = initialOrderItems, action) => {
  switch (action.type) {
    case GET_ORDER_ITEMS:
      return {
        ...state,
        orderItemsData: action.payload.itemDetails.map((items) => {
          let itemDetail = items?.details;
          return {
            ...items,
            productType: itemDetail?.bookId ? "Book" : "Course",
            name: itemDetail?.bookId
              ? itemDetail?.bookId?.title
              : itemDetail?.productId?.title,
            quantity: itemDetail?.qty,
            price: itemDetail?.price,
            status: itemDetail?.status,
          };
        }),

        orderItemsCount: action.payload.totalCount,
      };
    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };

    default:
      return state;
  }
};

export default OrderItemsReducer;
